import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { navData } from '../../nav-config-main';
import { NavList } from '../nav/mobile/nav-mobile-list';
import { AccountDrawer } from '../../components/account-drawer';
import { AddProductButton } from '../../components/add-product-button';
import { ShoppingCartButton } from '../../components/shopping-cart-button';

// ----------------------------------------------------------------------

export function FooterMobile({ sx }) {
  return (
    <Box
      component="footer"
      sx={[
        {
          py: 1.5,
          width: 1,
          bottom: -1,
          zIndex: 999,
          position: 'fixed',
          bgcolor: 'background.paper',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-evenly" sx={{ width: 1 }}>
        {navData.map((list) => (
          <NavList onlyIcon key={list.title} data={list} />
        ))}

        {/** @slot Add Product button */}
        <AddProductButton />

        {/** @slot Cart button */}
        <ShoppingCartButton />

        {/** @slot Account drawer */}
        <AccountDrawer />
      </Stack>
    </Box>
  );
}
